/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";
import ajaxBank from "../../util/remote/ajaxBank";

function MessageTransactions() {
  const [messageTransactions, setMessageTransactions] = useState(false);
  const [messageSearchTerm, setMessageSearchTerm] = useState("");
  const [messageStartDate, setMessageStartDate] = useState("");
  const [messageEndDate, setMessageEndDate] = useState("");
  
  const [messagePage,setMessagePage] = useState(1)
  const [messageMeta,setMessageMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  
  const getMessageTransactions = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxBank.fetchMessageTransactions(currentPage);
    setLoading(false);
    if (server_response.status === "OK") {
      setMessageMeta(server_response.details.meta.totalPages);
      setMessageTransactions(server_response.details.list || []);
    } else {
      setMessageTransactions([]);
    }
  };

  const searchMessageTransactions = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchMessageTransactions(messageSearchTerm, messageStartDate, messageEndDate, messagePage);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMessageMeta(server_response.details.meta.totalPages);
        setMessageTransactions(server_response.details.list || []);
      } else {
        setMessageTransactions([]);
      }
    
    };
  const setMessage = (e) => {
    e.preventDefault();
    setMessageSearchTerm("");
    setMessageStartDate("");
    setMessageEndDate("");
    setMessagePage(1);
    getMessageTransactions(1);
    
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= messageMeta) {
      setMessagePage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "User Details", key: "user" },
    { label: "Amount", key: "cash_out" }

  ];

  useEffect(() => {
    if (messageSearchTerm || messageStartDate || messageEndDate) {
      searchMessageTransactions();
    } else {
      getMessageTransactions(messagePage);
    }
  }, [messagePage]);

  return (
      <>
      <div class="heading-layout1 mg-b-5">
        <TableHeader subtitle="List of all the message transactions made sorted by the most recent"/>

        
      </div>

      <TransactionsSearchForm searchTerm={messageSearchTerm} setSearchTerm={setMessageSearchTerm} startDate={messageStartDate}
         setStartDate={setMessageStartDate} endDate={messageEndDate} setEndDate={setMessageEndDate} searchTransactions={searchMessageTransactions}
         setTransactions={setMessage} setPage={setMessagePage} searchTermPlaceholder="Enter first or last name of user..."/>

      <div className="border-top mt-3"></div>
              
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={messageTransactions} isPMTransaction={true}/>
        )}
      </div>

      <Pagination currentPage={messagePage} totalPages={messageMeta} onPageChange={handlePagination}/>
    </>
     
  );
}

export default MessageTransactions;
